import { render, staticRenderFns } from "./Fixtures.vue?vue&type=template&id=6793a514&scoped=true"
import script from "./Fixtures.vue?vue&type=script&lang=js"
export * from "./Fixtures.vue?vue&type=script&lang=js"
import style0 from "./Fixtures.vue?vue&type=style&index=0&id=6793a514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6793a514",
  null
  
)

export default component.exports